import styled from 'styled-components';
import { mediaQueries } from "../../../utils/device";
import TextSubHeading from "../../textComponents/TextSubHeading";
import Button from "../../Button";
import { IconClose } from "../../Icon";
export var Container = styled.div.withConfig({
  displayName: "ToolTipstyles__Container",
  componentId: "sc-nw75qc-0"
})(["box-sizing:border-box;display:flex;flex-direction:column;border:1px solid #dfdede;position:absolute;top:60px;right:", ";left:", ";padding:20px;margin-right:-30px;border-radius:10px;width:235px;&:before,&:after{content:'';position:absolute;bottom:100%;border-left:10px solid transparent;border-right:10px solid transparent;right:", ";left:", ";}&:before{border-bottom:10px solid #dfdede;margin-bottom:0;}&:after{border-bottom:10px solid #fff;margin-bottom:-1px;z-index:1;}@media ", "{width:270px;}"], function (_ref) {
  var direction = _ref.direction;
  return direction === 'right' && '50%';
}, function (_ref2) {
  var direction = _ref2.direction;
  return direction === 'left' && '0';
}, function (_ref3) {
  var direction = _ref3.direction;
  return direction === 'right' && '20px';
}, function (_ref4) {
  var direction = _ref4.direction;
  return direction === 'left' && '20px';
}, mediaQueries.medium);
export var Close = styled(IconClose).withConfig({
  displayName: "ToolTipstyles__Close",
  componentId: "sc-nw75qc-1"
})(["align-self:flex-end;cursor:pointer;position:absolute;"]);
export var ActionButton = styled(Button).withConfig({
  displayName: "ToolTipstyles__ActionButton",
  componentId: "sc-nw75qc-2"
})(["margin-top:16px;"]);
export var Heading = styled(TextSubHeading).withConfig({
  displayName: "ToolTipstyles__Heading",
  componentId: "sc-nw75qc-3"
})(["margin-top:4px;margin-bottom:4px;"]);
//# sourceMappingURL=ToolTip.styles.js.map